export default __webpack_public_path__ + "static/ritual_face_1-0d31559182d58fe4486d30fe0d3730c8.svg";